import * as c from "react";
import { p as a } from "./index-efd35e77.js";
import { t as d } from "./ButtonGroup-a9850ef0.js";
import { v as h, p as m, c as b } from "./package-metadata-9ad1330d.js";
import { K as p } from "./keys-2b65407d.js";
import { k as y } from "./theme-b013fa81.js";
var g = globalThis && globalThis.__extends || function() {
  var f = function(n, e) {
    return f = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, o) {
      t.__proto__ = o;
    } || function(t, o) {
      for (var r in o)
        Object.prototype.hasOwnProperty.call(o, r) && (t[r] = o[r]);
    }, f(n, e);
  };
  return function(n, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    f(n, e);
    function t() {
      this.constructor = n;
    }
    n.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
  };
}(), l = globalThis && globalThis.__assign || function() {
  return l = Object.assign || function(f) {
    for (var n, e = 1, t = arguments.length; e < t; e++) {
      n = arguments[e];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (f[o] = n[o]);
    }
    return f;
  }, l.apply(this, arguments);
}, z = (
  /** @class */
  function(f) {
    g(n, f);
    function n(e) {
      var t = f.call(this, e) || this;
      return t._element = null, t.offsetHeight = 0, t.offsetWidth = 0, t.buttons = [], t.focusedSelector = t.selectors.map(function(o) {
        return o + ":focus";
      }).join(","), t.setTabIndex = function(o) {
        var r = t.props.tabIndex, i = r === void 0 ? n.defaultProps.tabIndex : r;
        t.buttons.forEach(function(s, u) {
          s.tabIndex = u === o ? i : -1;
        });
      }, t.onKeyDown = function(o) {
        var r = o.target, i = o.keyCode === p.left || o.keyCode === p.right;
        if (!(!i || o.defaultPrevented || t.buttons.findIndex(function(u) {
          return u === r;
        }) === -1)) {
          var s = t.focusedIndex;
          o.keyCode === p.left ? t.focusButton(s, s - 1) : t.focusButton(s, s + 1);
        }
      }, t.onWindowResize = function(o) {
        var r = t.element;
        if (r) {
          var i = r.offsetWidth, s = r.offsetHeight;
          if (t.offsetWidth !== i || t.offsetHeight !== s) {
            t.offsetWidth = i, t.offsetHeight = s;
            var u = { offsetWidth: t.offsetWidth, offsetHeight: t.offsetHeight };
            t.props.onResize && t.props.onResize.call(void 0, l(l({ target: t }, u), { nativeEvent: o }));
          }
        }
      }, h(m), t;
    }
    return Object.defineProperty(n.prototype, "selectors", {
      get: function() {
        return this.props.buttons || d;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "focusedIndex", {
      get: function() {
        var e = this.element && this.element.querySelector(this.focusedSelector);
        return Math.max(0, this.buttons.findIndex(function(t) {
          return t === e;
        }));
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "element", {
      /**
       * Returns the HTML element of the Toolbar component.
       */
      get: function() {
        return this._element;
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.componentDidMount = function() {
      window.addEventListener("resize", this.onWindowResize);
      var e = this.element;
      e && (this.offsetWidth = e.offsetWidth, this.offsetHeight = e.offsetHeight, this.props.keyboardNavigation !== !1 && (this.buttons = Array.from(e.querySelectorAll(this.selectors.join(","))), this.setTabIndex(0)));
    }, n.prototype.componentDidUpdate = function() {
      var e = this.element;
      !e || this.props.keyboardNavigation === !1 || (this.buttons = Array.from(e.querySelectorAll(this.selectors.join(","))), this.setTabIndex(this.focusedIndex));
    }, n.prototype.componentWillUnmount = function() {
      window.removeEventListener("resize", this.onWindowResize), this.buttons.length = 0;
    }, n.prototype.render = function() {
      var e, t = this;
      return c.createElement("div", { id: this.props.id, "aria-label": this.props.ariaLabel, className: b("k-toolbar", (e = {}, e["k-toolbar-".concat(y.sizeMap[this.props.size] || this.props.size)] = this.props.size, e), this.props.className), style: this.props.style, role: this.props.role !== void 0 ? this.props.role || void 0 : "toolbar", dir: this.props.dir, ref: function(o) {
        return t._element = o;
      }, onKeyDown: this.props.keyboardNavigation !== !1 ? this.onKeyDown : void 0 }, this.props.children);
    }, n.prototype.focusButton = function(e, t) {
      var o = this.props.tabIndex, r = o === void 0 ? n.defaultProps.tabIndex : o, i = this.buttons[t];
      if (i) {
        i.tabIndex = r, i.focus();
        var s = this.buttons[e];
        s && (s.tabIndex = -1);
      }
    }, n.propTypes = {
      tabIndex: a.number,
      dir: a.string,
      keyboardNavigation: a.bool,
      style: a.object,
      className: a.string,
      role: a.string,
      onResize: a.func,
      buttons: a.arrayOf(a.string),
      size: a.oneOf([null, "small", "medium", "large"])
    }, n.defaultProps = {
      tabIndex: 0,
      size: "medium"
    }, n;
  }(c.Component)
);
export {
  z as T
};
